export default __webpack_public_path__ + "static/media/maine.d27157ea.jpg";